<!--
 * @Author: cgh
 * @Date: 2022-09-23
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 11:40:20
 * @Description: 成员信息添加、修改窗口
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-60 o-dialog--xl-50"
    title="修改"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :rules="fdRules"
        :inline="true"
        label-position="right"
        label-width="150px"
        label-suffix="："
      >
        <el-row class="c-form__row">
          <!-- <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="用户编码"
              prop="userVO.userCode"
            >
              <el-input
                v-if="!this.$route.params.userCode"
                v-model.trim="fd.userVO.userCode"
                class="c-form__input"
                placeholder=""
                @change="handleUserCodeChange"
              />
              <span
                v-else
                class="c-form__read"
              >
                {{ fd.userVO.userCode }}
              </span>
            </el-form-item>
          </el-col> -->
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="机构编码"
              prop="userVO.userCode"
            >
              <span
                class="c-form__read"
              >
                {{ fd.userVO.userCode }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="机构名称"
              prop="userVO.userName"
            >
              <el-input
                v-model.trim="fd.userVO.userName"
                class="c-form__input"
                placeholder=""
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="账号类型"
              prop="userVO.SFZZH"
            >
              <span
                class="c-form__read"
              >
                {{ fd.userVO.SFZZH === 'Y' ? '主账号': '公司子账号' }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="联系人"
              prop="userVO.LXR"
            >
              <el-input
                v-model.trim="fd.userVO.LXR"
                class="c-form__input"
                placeholder=""
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="联系电话"
              prop="userVO.tel"
            >
              <!-- <span
                class="c-form__read"
              >
                {{ fd.userVO.tel }}
              </span> -->
              <el-input
                v-model.trim="fd.userVO.tel"
                class="c-form__input"
                placeholder=""
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="创建时间"
              prop="userVO.createTime"
            >
              <span
                class="c-form__read"
              >
                {{ fd.userVO.createTime | date('yyyy-MM-dd') }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="身份有效期止"
              prop="capacityVO.effectEndDate"
            >
              {{ fd.capacityVO.effectEndDate | date('yyyy-MM-dd') }}
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="备注"
              prop="userVO.BZ"
            >
              <el-input
                v-model.trim="fd.userVO.BZ"
                type="textarea"
                :rows="3"
                class="c-form__input"
                placeholder=""
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="保存"
        :auth-type="true"
        type="primary"
        @click="handleSave()"
      />
      <el-button @click="closeDialog()">
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { userService, roleCapacityService } from './account.service.js';
import EditUser from '@/features/system/attr/user/editUser.vue';
// 继承于新增用户
export default {
  name: 'AddDialog',
  extends: EditUser,
  data () {
    return {
      dialogShow: true, // 模态框dialog显示

      loading: false, // 页面是否加载
      /* 表单参数 Start */

      disabled: false,
      showDialogName: null,
      editCapacityVo: true, // 该用户已经存在部门信息，选择新增用户身份

      roleList: [], // 岗位列表
      roleFilter: {
        userCode: null,
        deptCode: null
      },
      /* 表单校验规则 Start */
      fdRules: {
        'userVO.userCode': [
          this.$validUtils.required('用户编码'),
          this.$HMValidator.maxLength('用户编码', 36)
        ],
        'userVO.userName': [
          this.$validUtils.required('用户名称'),
          this.$HMValidator.maxLength('用户名称', 75)
        ],
        'userVO.tel': [
          this.$validUtils.required('联系电话'),
          this.$HMValidator.maxLength('联系电话', 11)
        ],
        'userVO.LXR': [
          this.$validUtils.required('联系人'),
          this.$HMValidator.maxLength('联系人', 75)
        ]

      }
      /* 表单校验规则 End */
    };
  },

  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },

    handleSave () {
      this.$refs.fd.validate((valid) => {
        this.fd.userVO.attrs.SFZZH = this.fd.userVO.SFZZH;
        this.fd.userVO.attrs.BZ = this.fd.userVO.BZ;
        this.fd.userVO.attrs.LXR = this.fd.userVO.LXR;
        if (valid) {
          this.loading = true;
          this.fd.capacityVO.capacityName = this.fd.userVO.userName;
          userService.update(this.fd)
            .then(rsp => {
              this.handleSaveRole();
            })
            .catch(err => {
              console.error('修改保存出错', err);
            }).finally(() => {
              this.loading = false;
            }); ;
        }
      });
    },
    /**
     * @description: 查询所有可关联岗位列表
     * @param {*}
     * @return {*}
     */
    getRoleList () {
      const currentUser = this.$HMStoreService.getUserinfo();
      this.roleFilter.userCode = currentUser.capacity.capacityCode;
      this.roleFilter.deptCode = currentUser.capacity.deptCode;
      roleCapacityService.getWglRoleList(this.roleFilter.userCode, this.roleFilter.deptCode)
        .then(rsp => {
          this.roleList = rsp.data.list.filter((item) => {
            return item.roleCode !== 'projectsManage';
          });
        })
        .catch(err => {
          console.error('查询岗位错误', err);
        });
    },
    /**
     * @description: 查询已关联岗位列表
     * @param {*}
     * @return {*}
     */
    getYglRoleList () {
      roleCapacityService.getYglRoleList(this.fd.userVO.userCode)
        .then(rsp => {
          // const roleList = rsp.data.list.filter((item) => {
          //   return item.roleCode !== 'PUBLIC' && item.roleCode !== 'user' && item.roleCode !== 'projectsManage';
          // });
          this.fd.roleList = rsp.data.list.map((item) => {
            return item.deptRoleUuid;
          });
        })
        .catch(err => {
          console.error('查询已关联岗位错误', err);
        });
    },
    /**
     * @description: 岗位关联保存操作
     * @param {*}
     * @return {*}
     */
    handleSaveRole () {
      this.loading = true;
      roleCapacityService.save({
        capacityCode: this.fd.userVO.userCode, // 用户身份uuid
        deptRoleUuid: this.fd.roleList // 已关联岗位uuid
      })
        .then(rsp => {
          this.$alert('修改成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }

          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.log('岗位关联保存错误', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 初始化
     * 1.后台获取用户信息
     * 2.后台获取扩展字段
     * 3.扩展字段添加到表单变量里面，整合扩展字段值到扩展属性对象里面
     * 4.后台获取组织机构
     * @param {*}
     * @return {*}
     */
    async init () {
      this.loading = true;
      this.getRoleList();
      await this.initUserByCode();
      this.getAttr();
      this.getYglRoleList();
    }
  },
  created () {
    this.$set(this.fd, 'roleList', []);
  }
};
</script>
